"use client";

import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const SideItemHelper = ({ children }: { children: React.ReactNode }) => {
  const target = useRef<HTMLElement | null>(
    document?.getElementById("subnav-side-element")
  );
  useEffect(() => {
    if (!target.current) {
      target.current = document?.getElementById("subnav-side-element");
    }
  }, []);

  return <>{target?.current && createPortal(children, target.current)}</>;
};

export { SideItemHelper };
